module.exports = __webpack_public_path__ + "assets/img/more-btn-b54497fe.png";